
import AlignCenter from '../../../../element/icons/align-center';
import LineHeight from '../../../../element/icons/line-height';
import Spacing from '../../../../element/icons/spacing';

import { POPPABLE_OPTIONS } from '../../../../components/common/AnnotationOptions/AnnotationOptions.constants';
import LetterSpacingField from './LetterSpacingField';
import LineHeightField from './LineHeightField';
import TextAlignmentFields from './TextAlignmentFields';

export const TEXT_ALIGNMENT = 'text-alignment';
export const TEXT_LETTER_SPACING = 'text-letter-spacing';
export const TEXT_LINE_HEIGHT = 'text-line-height';
export const FIT_TEXT_TO_CONTENT = 'fit-text-to-content';

export const TEXT_POPPABLE_OPTIONS = [
  {
    titleKey: 'textAlignment',
    labelKey: 'textAlignmentShort',
    name: TEXT_ALIGNMENT,
    Icon: AlignCenter,
  },
  {
    titleKey: 'letterSpacing',
    labelKey: 'letterSpacingShort',
    name: TEXT_LETTER_SPACING,
    Icon: Spacing,
  },
  {
    titleKey: 'lineHeight',
    labelKey: 'lineHeightShort',
    name: TEXT_LINE_HEIGHT,
    Icon: LineHeight,
  },
];

/** Side-by-side inspector rows for Draw → Text (saves vertical scroll). */
export const TEXT_OPTION_ROW_GROUPS = [
  [TEXT_ALIGNMENT, FIT_TEXT_TO_CONTENT],
  [TEXT_LETTER_SPACING, TEXT_LINE_HEIGHT],
  [POPPABLE_OPTIONS.OPACITY, POPPABLE_OPTIONS.STROKE],
  [POPPABLE_OPTIONS.SHADOW, POPPABLE_OPTIONS.POSITION],
];

export const textOptionsPopupComponents = {
  [TEXT_ALIGNMENT]: TextAlignmentFields,
  [TEXT_LETTER_SPACING]: LetterSpacingField,
  [TEXT_LINE_HEIGHT]: LineHeightField,
};
